import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './WalkingNotice.module.scss';

interface WalkingNoticeProps {
    children: React.ReactNode;
}

export const WalkingNotice: React.FC<WalkingNoticeProps> = ({ children }) => {
    return (
        <div className={classes.root}>
            <FontAwesomeIcon icon={faInfoCircle} className={classes.icon} />
            <div className={classes.body}>{children}</div>
        </div>
    );
};
